import shuffleArray from "../../../objects/CommonUse/shuffleArray";
import MoneyMgmtTestDataset from "../Datasets/money_mgmt_test_dataset_mult";
import MoneyMgmtTestTopicList from "../Datasets/money_mgmt_test_topic_list";

export const createTestQuestionList = () => {
    const testQuestionList = MoneyMgmtTestDataset.topicList;
    let outputQuestionList = [];
    for (let i=0; i<testQuestionList.length; i++){
        let questionList = JSON.parse(JSON.stringify(testQuestionList[i].questionList));
        //  determine number of questions for each topic
        const topicList = MoneyMgmtTestTopicList;
        const topicListObj = topicList.find(elem => elem.testTopic === testQuestionList[i].topic);
        let nbrQuestions = 1;
        if (topicListObj){
            nbrQuestions = topicListObj.nbrQuestions;
        } 
        questionList = shuffleArray(questionList);
        const selectedQuestions = questionList.slice(0,nbrQuestions);
        outputQuestionList = outputQuestionList.concat(selectedQuestions);
    }
    for (let i=0; i<outputQuestionList.length; i++){
        outputQuestionList[i].answerList = shuffleArray(outputQuestionList[i].answerList);
    }
    outputQuestionList = shuffleArray(outputQuestionList);
    return outputQuestionList;

}
export default createTestQuestionList;